import CreditsResource from "./credits.resource";

const creditsModule = angular
  .module("app.resources.credits", [])
  .service("Credits", CreditsResource);

export default creditsModule;



// WEBPACK FOOTER //
// ./src/resources/credits/credits.module.js